import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  CustomCollapseCard,
  CustomImage,
  CustomModal,
  CustomPopover,
  errorDialog,
  Text,
  useText,
  warningDialog,
} from '@src/components';
import { Affix, Button } from 'antd';
import { MobilExpressPaymentTypeCode, VouIdCode, monthsList } from '@src/store/enums';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import { moneyFormat } from '@src/utils/utils';
import {
  Cancel,
  finishPaymentProcess,
  processPayment,
  setCreditCardMatchVous,
  setPayLaterDayForThanksPage,
  setSelectStoredCard,
  setPayWithLinkinEmail,
} from '@src/store/slice/mobilExpressSlice';
import modalClose from '@src/assets/icons/icon-close.svg';
import { cardOrdersUpdate } from '@src/store/slice/cardOrderSlice';
import PayWithNewCardCompliments from '@src/pages/ticketRestaurant/paymentModals/payWithNewCardCompliments/payWithNewCardCompliments';
import PayWithNewCard from '@src/pages/ticketRestaurant/paymentModals/payWithNewCard/payWithNewCard';
import PayWithEFTHavale from '@src/pages/ticketRestaurant/paymentModals/payWithEFTHavale/payWithEFTHavale';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import logoMobilExpress from '@src/assets/images/cardOrders/logo-mobilexpress.webp';
import logoAmex from '@src/assets/images/cardOrders/american-express-logo.png';
import logoVisa from '@src/assets/images/cardOrders/visa-inc-logo.svg';
import masterCardLogo from '@src/assets/images/cardOrders/mastercard-logo.svg';
import { createPortal } from 'react-dom';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import classNames from 'classnames';
import { confirmDialog } from '@src/components/CustomDialog';
import PropTypes from 'prop-types';
import PayWithSavedCardCompliments from '../../paymentModals/payWithSavedCardCompliments/payWithSavedCardCompliments';
import { getCustomerVouListForGift } from '@src/store/slice/customerSlice';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';

let paymentOrderDueDate = null;
let _selectedStoredCard = null;

const OrderSummary = ({ form, formVisible }) => {
  const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

  const isEnglishLanguage = () => getCurrentLanguage() === 'en';
  const isEnglish = isEnglishLanguage();
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { selectedStoredCard, paymentType, payWithLinkinEmail, payLaterDayForThanksPage } =
    useSelector((state) => state?.mobilExpress);
  const [invoiceMonthText, setInvoiceMonthText] = useState('');
  const [threeDSecureContent, setThreeDSecureContent] = useState('');
  const [saveCardBody, setSaveCardBody] = useState({ body: {}, checked: false });
  const dispatch = useDispatch();
  const [modals, setModals] = useState({
    threeDSecureModalVisible: false,
    instantRemittanceModalVisible: false,
    payWithNewCard: false,
    payWithEftHavale: false,
    payWithNewCardForCompliment: false,
    payWithSavedCardForCompliment: false,
  });
  const [afterMount, setAfterMount] = useState(false);
  const [isPayDayToday, setIsPayDayToday] = useState(false);
  const [showPayLater, setShowPayLater] = useState(false);
  const [enteredComplimentsModal, setEnteredComplimentsModal] = useState(false);
  const [enteredComplimentsClickValue, setEnteredComplimentsClickValue] = useState(0);
  const modalAction = (prop, value) => {
    setModals((modals) => ({
      ...modals,
      [prop]: value,
    }));
  };
  const customerId = selectedCustomer?.customerId;
  const [isValid, setIsValid] = useState(false);
  const [payWhenBalanceActiveDate, setPayWhenBalanceActiveDate] = useState(false);
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const pleaseSelectOneOfYourStoredCards = useText('pleaseSelectOneOfYourStoredCards');
  const threeDSecurity = useText('3dSecurity');
  const confirmLaterTextText = useText('confirmLaterText');
  const confirmLaterEmailTextText = useText('confirmLaterEmailText');
  const confirmSavedLaterTextText = useText('confirmSavedLaterText');
  const isComplimentsVou = useMemo(
    () => currentCardOrder?.vouId === VouIdCode.Compliments,
    [currentCardOrder],
  );
  const isMarketVou = useMemo(
    () => currentCardOrder?.vouId === VouIdCode.Market,
    [currentCardOrder],
  );

  let textTRorTG;
  let vouId;

  switch (currentCardOrder?.vouId) {
    case VouIdCode.Compliments:
      textTRorTG = 'Ticket Gift';
      vouId = VouIdCode.Compliments;
      break;

    case VouIdCode.Market:
      textTRorTG = 'Ticket Market';
      vouId = VouIdCode.Market;
      break;

    case VouIdCode.Restaurant:
    default:
      textTRorTG = 'Ticket Restaurant';
      vouId = VouIdCode.Restaurant;
      break;
  }

  useEffect(() => {
    (async () => {
      const values = await form?.getFieldsValue();

      const cardNumber = values?.cardNumber?.replaceAll('_', '').replaceAll('-', '');
      const cardNumberLength = cardNumber?.length;
      const cardNumberIsValid = cardNumberLength === 16;

      const cardHolderName = values?.cardHolderName;
      const cardHolderNameIsValid = cardHolderName?.length > 0;

      const lastMonth = values?.lastMonth;
      const lastMonthIsValid = lastMonth > 0;

      const lastYear = values?.lastYear;
      const lastYearIsValid = lastYear?.length > 0;

      const cvv = values?.cvv?.replaceAll('_', '');
      const cvvIsValid = cvv?.length > 2;

      setIsValid(
        cardNumberIsValid &&
        cardHolderNameIsValid &&
        lastMonthIsValid &&
        lastYearIsValid &&
        cvvIsValid,
      );
    })();
  }, []);

  useEffect(() => {
    const today = dayjs().hour(23).minute(59).second(59);
    const activationDate = dayjs(currentCardOrder?.cardActivationDate)
      .hour(23)
      .minute(59)
      .millisecond(0)
      .second(59);
    setShowPayLater(activationDate.isAfter(today));
    setIsPayDayToday(activationDate.unix() === today.unix());
    setAfterMount(activationDate.month() > today.month() || activationDate.year() > today.year());
  }, [currentCardOrder]);

  useEffect(() => {
    const text = monthsList
      .filter((month) => month.value === currentCardOrder?.invoiceMonth)
      .reduce((acc, month) => month.text, '');

    setInvoiceMonthText(text);
  }, [currentCardOrder]);

  const paymentLater = async () => {
    if (
      (isComplimentsVou || isMarketVou) &&
      paymentType !== MobilExpressPaymentTypeCode.EftHavale
    ) {
      if (enteredComplimentsModal) {
        showPaymentLaterSecondStep(enteredComplimentsClickValue);
      } else {
        modalAction('payWithSavedCardForCompliment', true);
      }
    } else {
      modalAction('payWithNewCard', false);
      await finishOrder(true);
    }
  };

  useEffect(() => {
    _selectedStoredCard = selectedStoredCard;
  }, [selectedStoredCard]);

  const finishOrder = async (paymentLater = false, vals = undefined) => {
    const body = {
      ...currentCardOrder,
      paymentLater,
      orderStatus: 90,
      sendMail: true,
    };
    if (paymentOrderDueDate && paymentType === MobilExpressPaymentTypeCode.CreditCard) {
      paymentOrderDueDate = null;
      body.cardToken = _selectedStoredCard;
    }
    if (formVisible) {
      const formData = await form.getFieldsValue();
      const cardBin = formData.cardNumber?.replaceAll('-', '')?.slice(0, 6) || '';
      if (cardBin) {
        body.cardBin = cardBin;
      }
      await form.resetFields();
    }
    if ((isComplimentsVou || isMarketVou) && paymentLater && vals === 2)
      body.dontSendBinAndToken = true;
    if (isComplimentsVou || isMarketVou) {
      const giftCustomerInfo = await dispatch(
        getCustomerVouListForGift({
          customerId: selectedCustomer?.customerId,
          vouId: vouId,
        }),
      );
      if (giftCustomerInfo?.payload?.data[0]?.pamId) {
        body.paymentType = giftCustomerInfo?.payload?.data[0]?.pamId;
      }
      if (paymentType === MobilExpressPaymentTypeCode.EftHavale) {
        body.paymentType = 5;
      }
    }
    if (paymentType == MobilExpressPaymentTypeCode.EftHavale) {
      body.dontSendBinAndToken = true;
    }
    await dispatch(cardOrdersUpdate(body));
  };

  useEffect(() => {
    window.paymentLater = paymentLater;
    return () => {
      window.paymentLater = () => { };
    };
  }, [paymentLater]);

  const setPaymentOrderDueDate = (value) => (paymentOrderDueDate = value);

  const saveNewCardWithParam = async (price, isDump) => {
    const customerId = selectedCustomer?.customerId;
    const values = await form.validateFields();
    const body = {
      body: {
        currency: 'TRY',
        paymentInstrument: 'NewCard',
        paymentInstrumentInfo: {
          newCard: {
            processType: isDump ? 'preauth' : 'sales',
            use3DSecure: true,
            cvv: values?.cvv,
            cardInfo: {
              cardHolderName: values?.cardHolderName,
              cardNumber: values?.cardNumber?.replaceAll('-', ''),
              lastMonth: values?.lastMonth,
              lastYear: values?.lastYear,
            },
          },
        },
        returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=NewCard${isDump ? '&PaymentReferenceType=preauth' : ''
          }`,
        totalAmount: price,
        customerInfo: { customerId: customerId?.toString() },
      },
      paymentReferenceType: isDump ? 3 : 1,
      referenceId: isDump ? '1' : currentCardOrder?.id?.toString(),
    };
    return dispatch(processPayment(body));
  };

  const saveNewCardPayLater = async () => {
    const action = await saveNewCardWithParam(1, true);
    const values = await form.validateFields();
    if (processPayment.fulfilled.match(action)) {
      const data = action?.payload?.data;
      if (data?.result === 'Success') {
        await handleOrderFinish();
        return;
      }
      modalAction('payWithNewCard', false);
      setThreeDSecureContent(
        'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
      );
      modalAction('threeDSecureModalVisible', true);
      setSaveCardBody({ body: values, checked: true });
    }
  };

  const saveNewCard = async () => {
    modalAction('payWithNewCard', false);
    const values = await form.validateFields();
    try {
      const action = await saveNewCardWithParam(currentCardOrder?.totalPrice, false);
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish();
          return;
        }
        setThreeDSecureContent(
          'data:text/html;charset=utf-8,' + encodeURIComponent(action?.payload?.data?.redirectForm),
        );
        modalAction('threeDSecureModalVisible', true);
        if (values.cardSaveChecked) {
          setSaveCardBody({ body: values, checked: true });
        }
      }
    } catch (e) { }
  };

  async function formVisibleMedhod() {
    const values = await form.validateFields();
    const { cardSaveChecked } = values;
    if (isPayDayToday || !afterMount) {
      await saveNewCard();
    } else if (afterMount) {
      if (cardSaveChecked) {
        await saveNewCardPayLater();
      } else {
        modalAction('payWithNewCard', true);
      }
    }
  }

  const handlePayment = useCallback(async () => {
    if (paymentType === MobilExpressPaymentTypeCode.EftHavale) {
      modalAction('payWithEftHavale', true);
      return;
    }
    const customerId = selectedCustomer?.customerId;
    if (formVisible) {
      await formVisibleMedhod();
    } else {
      const body = {
        body: {
          currency: 'TRY',
          paymentInstrument: 'StoredCard',
          paymentInstrumentInfo: {
            storedCard: {
              processType: 'sales',
              use3DSecure: false,
              cardToken: selectedStoredCard,
            },
          },
          returnUrl: `${process.env.VITE_SITE_URL}/payment-result.html?paymentInstrument=StoredCard`,
          customerInfo: { customerId: customerId?.toString() },
          totalAmount: currentCardOrder?.totalPrice,
        },
        paymentReferenceType: 1,
        referenceId: currentCardOrder?.id?.toString(),
      };
      await dispatch(setLoadingState(true));
      const action = await dispatch(processPayment(body));
      if (processPayment.fulfilled.match(action)) {
        const data = action?.payload?.data;
        if (data?.result === 'Success') {
          await handleOrderFinish();
        } else {
          setThreeDSecureContent(
            'data:text/html;charset=utf-8,' +
            encodeURIComponent(action?.payload?.data?.redirectForm),
          );
          modalAction('threeDSecureModalVisible', true);
        }
      }
      await dispatch(setLoadingState(false));
    }
  }, [
    dispatch,
    form,
    formVisible,
    selectedStoredCard,
    selectedCustomer,
    currentCardOrder,
    payLaterDayForThanksPage,
    paymentType,
    saveNewCard,
    saveNewCardPayLater,
    isPayDayToday,
  ]);

  useEffect(() => {
    window.handlePayment = isVerifiedPayment;
    return () => {
      window.handlePayment = () => { };
    };
  }, [handlePayment]);

  const showPayLaterNewCardModal = () => {
    if (isComplimentsVou) {
      if (enteredComplimentsModal) {
        showPaymentLaterSecondStep(enteredComplimentsClickValue);
      } else {
        modalAction('payWithNewCardForCompliment', true);
      }
      return;
    }

    modalAction('payWithNewCard', true);
  };

  const handleStoredCardPayLater = async () => {
    if (selectedStoredCard) {
      await paymentLater();
      return;
    }

    warningDialog({
      title: <Text t="attention" />,
      message: pleaseSelectOneOfYourStoredCards,
    });
  };

  const payWhenBalanceActiveDay = async () => {
    paymentOrderDueDate = dayjs(currentCardOrder?.cardActivationDate)
      .utc(true)
      .utcOffset(180)
      .toISOString();
    await dispatch(setPayLaterDayForThanksPage(paymentOrderDueDate));
    if (!formVisible) {
      await handleStoredCardPayLater();
      return;
    }

    const values = await form.validateFields();
    const { cardSaveChecked } = values;
    setPayWhenBalanceActiveDate(true);

    if (cardSaveChecked) {
      await saveNewCardPayLater();
      return;
    }

    showPayLaterNewCardModal();
  };

  useEffect(() => {
    window.payWhenBalanceActiveDay = payWhenBalanceActiveDay;
    return () => {
      window.payWhenBalanceActiveDay = () => { };
    };
  }, [payWhenBalanceActiveDay]);

  const handleOrderFinish = useCallback(async () => {
    await finishOrder(false);
  }, [currentCardOrder, dispatch]);

  const handleDelayedPayment = async () => {
    if (formVisible) {
      modalAction('payWithNewCard', true);
      await form.validateFields();
    }
    paymentOrderDueDate = dayjs(currentCardOrder?.cardActivationDate)
      .utc(true)
      .utcOffset(180)
      .toISOString();
    await dispatch(setPayLaterDayForThanksPage(paymentOrderDueDate));
    if (!formVisible) await paymentLater();
  };

  const isVerifiedPayment = useCallback(() => {
    if (afterMount) return handleDelayedPayment();
    if (payWithLinkinEmail) return paymentLater();
    return handlePayment();
  }, [
    afterMount,
    currentCardOrder,
    dispatch,
    form,
    formVisible,
    handleOrderFinish,
    handlePayment,
    paymentType,
    payWithLinkinEmail,
  ]);

  const finishPaymentProcessHandlerFunc = useCallback(
    async (body) => {
      try {
        const action = await dispatch(finishPaymentProcess(body));
        if (finishPaymentProcess.fulfilled.match(action)) {
          if (body.paymentReferenceType === 3) {
            await dispatch(
              Cancel({
                body: {
                  orderId: body.body.orderId,
                  paymentInstrument: 'newCard',
                  transactionReason: 'Ön Provizyon İptal',
                },
              }),
            );
          }
          if (saveCardBody.checked) {
            const body = {
              saveCardBody: {
                customerInfo: {
                  customerId: customerId?.toString(),
                },
                cardHolterName: saveCardBody?.body?.cardHolderName,
                cardNumber: saveCardBody?.body?.cardNumber?.replaceAll('-', ''),
                cardMonth: saveCardBody?.body?.lastMonth,
                cardYear: saveCardBody?.body?.lastYear,
                selectedVous: [
                  {
                    vouId: 1,
                    vouName: 'TICKET RESTAURANT',
                  },
                ],
              },
              creditCartVouMatchList: [
                {
                  customerId: customerId?.toString(),
                  vouId: 1,
                  provisionDay: 0,
                  type: 0,
                },
              ],
            };
            const newCardResponse = await dispatch(setCreditCardMatchVous(body));
            if (setCreditCardMatchVous.fulfilled.match(newCardResponse)) {
              const newCardToken = newCardResponse?.payload?.data?.cardToken;
              await dispatch(setSelectStoredCard(newCardToken));
              _selectedStoredCard = newCardToken;
              paymentOrderDueDate = true;
            }
          }
          if (formVisible) {
            if (payWhenBalanceActiveDate) {
              setPayWhenBalanceActiveDate(false);
              if ((isComplimentsVou || isMarketVou) && saveCardBody.checked) {
                await finishOrder(true, 1);
                return;
              }
              await paymentLater();
              return;
            }
          }
          await handleOrderFinish();
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      } catch (e) { }
    },
    [
      dispatch,
      form,
      formVisible,
      handleOrderFinish,
      isComplimentsVou,
      isMarketVou,
      paymentLater,
      saveCardBody?.body,
      saveCardBody.checked,
    ],
  );

  const iframeOnLoad = useCallback(
    (queryString) => {
      if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const paymentInstrument = urlParams.get('paymentInstrument');
        const orderId = urlParams.get('OrderId');
        const systemTransId = urlParams.get('SystemTransId');
        const Result = urlParams.get('Result');
        const totalAmount = urlParams.get('TotalAmount');
        const paymentReferenceType = urlParams.get('PaymentReferenceType');

        const isPreAuth = paymentReferenceType === 'preauth';

        if (Result === '3DFailed' || Result === '') {
          modalAction('threeDSecureModalVisible', false);
          errorDialog({
            title: <Text t="error" />,
            message: <Text t="mobilExpressError" />,
          });
        } else if (paymentInstrument && orderId && systemTransId) {
          const body = {
            paymentReferenceType: 1,
            referenceId: currentCardOrder?.id,
            body: {
              orderId,
              merchantProcessId: 'IslemId33',
              systemTransId: systemTransId,
              paymentInstrument: paymentInstrument,
              paymentInstrumentInfo: {},
              totalAmount: +totalAmount,
            },
          };

          if (paymentInstrument === 'NewCard') {
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          } else {
            body.body.paymentInstrumentInfo = {
              storedCard: { otp: '', cvv: '' },
            };
          }

          if (isPreAuth) {
            body.paymentReferenceType = 3;
            body.referenceId = '1';
            body.body.paymentInstrumentInfo = {
              newCard: {},
            };
          }
          (async () => {
            await finishPaymentProcessHandlerFunc(body);
          })();
        } else {
          modalAction('threeDSecureModalVisible', false);
        }
      }
    },
    [currentCardOrder?.id, finishPaymentProcessHandlerFunc],
  );

  useEffect(() => {
    window.finishPaymentProcessHandler = iframeOnLoad;
    window.modalAction = modalAction;
    return () => {
      window.finishPaymentProcessHandler = () => { };
      window.modalAction = () => { };
    };
  }, [iframeOnLoad]);

  let isDisabled = false;
  if (paymentType === MobilExpressPaymentTypeCode.CreditCard) {
    isDisabled = formVisible ? !isValid : !selectedStoredCard;
  }

  const handlePayLater = useCallback(async () => {
    if (isComplimentsVou) {
      modalAction('payWithNewCardForCompliment', true);
      return null;
    }
    if (formVisible && isDisabled) {
      isComplimentsVou
        ? modalAction('payWithNewCardForCompliment', true)
        : modalAction('payWithNewCard', true);
      return null;
    }
    await payWhenBalanceActiveDay();
  }, [formVisible]);

  const renderTitleWithValue = (title) => (
    <span
      className={
        isComplimentsVou || isMarketVou ? 'compliments-payment-summary-text1' : 'summary-title'
      }
    >
      <Text t={title} />
    </span>
  );

  const renderPayLaterButton = () => (
    <button
      className={
        isComplimentsVou || isMarketVou
          ? 'compliments-payment-summary-later-pay'
          : classNames({
            'pay-when-balance-active-day-button': true,
            right: true,
          })
      }
      style={{
        backgroundColor: isComplimentsVou || isMarketVou ? '#162056' : 'transparent',
        borderWidth: isComplimentsVou || isMarketVou ? 1 : 0,
      }}
      onClick={handlePayLater}
    >
      <Text t="payLater" />
    </button>
  );

  const getButtonText = () => {
    if (isComplimentsVou || isMarketVou) return <Text t="confirmPayment" />;
    if (paymentType === MobilExpressPaymentTypeCode.EftHavale || afterMount) return <Text t="continue" />;
    return <Text t="payNow" />;
  };

  const isVisibleOrAfterAmount = () => {
    return afterMount && formVisible ? false : isDisabled;
  };

  const fizikselOrDigital = () => {
    return currentCardOrder?.cardType === 0 ? 'Fiziksel' : 'Dijital';
  };

  const confirmLaterText = (vals) => {
    if ((isComplimentsVou || isMarketVou) && vals === 1) {
      return confirmLaterTextText;
    } else if ((isComplimentsVou || isMarketVou) && vals === 2) {
      return confirmLaterEmailTextText;
    } else if (vals) {
      return confirmLaterTextText;
    } else
      return confirmLaterEmailTextText;
  };

  const confirmSavedLaterText = (vals) => {
    if ((isComplimentsVou || isMarketVou) && vals === 1) {
      return confirmSavedLaterTextText;
    } else if ((isComplimentsVou || isMarketVou) && vals === 2) {
      return confirmLaterEmailTextText;
    } else if (vals) {
      return confirmLaterTextText;
    } else
      return confirmLaterEmailTextText;
  };
  const showPaymentLaterSecondStep = (vals) => {
    if (isComplimentsVou || isMarketVou) {
      warningDialog({
        title: <Text t="attention" />,
        width: 640,
        htmlContent: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span className="compliments-med-text" style={{ textAlign: 'center' }}>
              <Text t="doYouApproveTheTransaction" />
            </span>
            <span style={{ textAlign: 'center' }}>{confirmLaterText(vals)}</span>
            <span style={{ textAlign: 'center' }}>
              <Text t="doYouWantToContinue" />
            </span>
            <button
              style={{ marginTop: 20 }}
              className="utts-ok-button comp-warn-confirm"
              onClick={async () => {
                callPaymentLaterFunc(vals);
              }}
            >
              <Text t="approve2" />
            </button>
            <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
              <Text t="giveUp" />
            </button>
          </div>
        ),
        className: 'warningModal-utts not-show-warning-buttons',
        okButtonProps: 'not-show-warning-buttons',
        onOk: async () => { },
        onCancel: async () => { },
      });
    } else {
      confirmDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span className="compliments-med-text" style={{ textAlign: 'center' }}>
              <Text t="doYouApproveTheTransaction" />
            </span>
            <span style={{ textAlign: 'center' }}>{confirmLaterText(vals)}</span>
            <span style={{ textAlign: 'center' }}>
              <Text t="doYouWantToContinue" />
            </span>
          </div>
        ),
        onOk: (val) => {
          callPaymentLaterFunc(vals);
        },
        onCancel: (val) => {
          console.log('onCancel', val);
        },
      });
    }
  };

  const showSavedPaymentLaterSecondStep = (vals) => {
    if (isComplimentsVou || isMarketVou) {
      warningDialog({
        title: <Text t="attention" />,
        width: 640,
        htmlContent: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span className="compliments-med-text" style={{ textAlign: 'center' }}>
              <Text t="doYouApproveTheTransaction" />
            </span>
            <span style={{ textAlign: 'center' }}>{confirmSavedLaterText(vals)}</span>
            <span style={{ textAlign: 'center' }}>
              <Text t="doYouWantToContinue" />
            </span>
            <button
              style={{ marginTop: 20 }}
              className="utts-ok-button comp-warn-confirm"
              onClick={async () => {
                callPaymentLaterFunc(vals);
              }}
            >
              <Text t="approve2" />
            </button>
            <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
              <Text t="giveUp" />
            </button>
          </div>
        ),
        className: 'warningModal-utts not-show-warning-buttons',
        okButtonProps: 'not-show-warning-buttons',
        onOk: async () => { },
        onCancel: async () => { },
      });
    } else {
      confirmDialog({
        title: <Text t="attention" />,
        okText: 'ONAYLA',
        cancelText: <Text t="giveUp" />,
        htmlContent: (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span className="compliments-med-text" style={{ textAlign: 'center' }}>
              <Text t="doYouApproveTheTransaction" />
            </span>
            <span style={{ textAlign: 'center' }}>{confirmSavedLaterText(vals)}</span>
            <span style={{ textAlign: 'center' }}>
              <Text t="doYouWantToContinue" />
            </span>
          </div>
        ),
        onOk: (val) => {
          callPaymentLaterFunc(vals);
        },
        onCancel: (val) => {
          console.log('onCancel', val);
        },
      });
    }
  };

  const callPaymentLaterFunc = async (vals) => {
    await dispatch(
      setPayLaterDayForThanksPage(
        dayjs(currentCardOrder?.cardActivationDate).utc(true).utcOffset(180).toISOString(),
      ),
    );
    if (isComplimentsVou || isMarketVou) {
      if (vals === 1) {
        await dispatch(setPayWithLinkinEmail(false));
        //await saveNewCardPayLater();
      } else {
        await dispatch(setPayWithLinkinEmail(true));
        setPaymentOrderDueDate(null);
      }
      await finishOrder(true, vals);
    } else {
      if (vals === 1) {
        try {
          await form.setFieldsValue({
            cardSaveChecked: true,
          });
          await form.validateFields();
        } catch (e) {
          console.error(e);
        }
        await dispatch(setPayWithLinkinEmail(false));
        await saveNewCardPayLater();
      } else {
        await dispatch(setPayWithLinkinEmail(true));
        setPaymentOrderDueDate(null);
        await paymentLater();
      }
    }
  };

  return (
    <div className="payment-order-summary-content">
      <CustomCollapseCard bodyCenter cardTitle={<Text t="orderSummary" />}>
        <div className="payment-order-summary-container">
          <div className="payment-order-summary-list">
            {isComplimentsVou || isMarketVou ? (
              <>
                <span className="compliments-payment-summary-text1"><Text t="cardType2" />:</span>
                <p>{fizikselOrDigital()}</p>
              </>
            ) : (
              <p>
                <Text t="cardType2" />: <span>{fizikselOrDigital()}</span>
              </p>
            )}
            {isComplimentsVou || isMarketVou ? (
              <span className="compliments-payment-summary-text1">
                <Text t="cardPrintingOptions" />
              </span>
            ) : null}
            <p>{currentCardOrder?.printNameSurname ? <Text t="printWithName" /> : <Text t="printWithoutName" />}</p>
            <p>
              {currentCardOrder?.printCompanyName ? <Text t="printWithCompanyName" /> : <Text t="printWithoutCompanyName" />}
            </p>
            <p>
              {currentCardOrder?.printCompanyLogo
                ? <Text t="printWithCompanyLogo" />
                : <Text t="printWithoutCompanyLogo" />}
            </p>

            {renderTitleWithValue('autoActivationDate')}:

            <p style={{ color: isComplimentsVou || isMarketVou ? '#00a483' : '#000' }}>
              {dayjs(currentCardOrder?.cardActivationDate).format(defaultDateFormat)}
            </p>

            {renderTitleWithValue('invoiceMonth2')}
            <p>{invoiceMonthText}</p>

            {renderTitleWithValue('invoiceAddress')}
            <p className="address-label">{currentCardOrder?.invoiceAddress}</p>
          </div>

          <div className="summary-info-box">
            <span className="summary-title">
              <Text t="numberOfCards3" />
            </span>
            <p>{currentCardOrder?.totalCount}</p>
          </div>

          <div className="summary-total-price-info-box">
            <span className="summary-title">
              <Text t="totalBalanceLoad" />
            </span>
            <p>{moneyFormat(currentCardOrder?.totalPrice, true)}</p>
          </div>

          <div className="summary-total-price-info-box">
            <span className="summary-title">
              <Text t="totalAmountToBePaid" />
            </span>
            <p>{moneyFormat(currentCardOrder?.totalPaymentAmount, true)}</p>
          </div>

          <span className="approval-text">
            {isEnglish ? (
              <>
                <Text t="iApproveTheOrderAndPaymentDetailedAbove2" /> {textTRorTG} <Text t="enteredIntoByOurCompany" />
              </>
            ) : (
              <>
                <Text t="enteredIntoByOurCompany" /> {textTRorTG} <Text t="iApproveTheOrderAndPaymentDetailedAbove2" />
              </>
            )}
          </span>
          {!isMobil &&
            showPayLater &&
            !afterMount &&
            currentCardOrder?.paymentType !== 5 &&
            renderPayLaterButton()}

          {!isMobil && (
            <Button
              id="cardOrders-payment-orderSummary-payment-btn"
              disabled={isVisibleOrAfterAmount()}
              className="payment-btn"
              onClick={isVerifiedPayment}
            >
              {getButtonText()}
            </Button>
          )}
        </div>
      </CustomCollapseCard>
      {currentCardOrder?.paymentType !== 5 && isMobil && (
        <div className="footer-logo">
          <div className="left-logos">
            <CustomImage className="logoMobil" src={logoMobilExpress} />
          </div>
          <span className={'pay-text'}>
            <Text t="yourCardsAreStoredSecurelyInThePci" />
          </span>
          <div className="right-logos">
            <CustomImage src={logoAmex} style={{ width: '50px', height: '50px' }} />
            <CustomImage src={logoVisa} />
            <CustomImage src={masterCardLogo} />
          </div>
        </div>
      )}

      {isMobil &&
        createPortal(
          <Affix offsetBottom={0}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#fff',
                padding: '18px 0',
              }}
            >
              <Button
                id="cardOrders-payment-orderSummary-second-payment-btn"
                disabled={isVisibleOrAfterAmount()}
                className="payment-btn"
                onClick={isVerifiedPayment}
              >
                {getButtonText()}
              </Button>
              {showPayLater && !afterMount && currentCardOrder.paymentType !== 5 && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                  }}
                >
                  {renderPayLaterButton()}
                  <CustomPopover
                    placement="topRight"
                    title={false}
                    content={
                      <div
                        style={{
                          width: '300px',
                          color: '#3f4957',
                          padding: '7px 18px',
                        }}
                      >
                        <Text t="ifYouSelectThisOptionTheTotalBalance" />
                      </div>
                    }
                    trigger="hover"
                    arrowPointAtCenter={true}
                  >
                    <div>
                      <CustomImage src={iconInfo} />
                    </div>
                  </CustomPopover>
                </div>
              )}
            </div>
          </Affix>,
          document.body,
        )}

      {modals.threeDSecureModalVisible && (
        <CustomModal
          width={500}
          maskClosable={false}
          footer={false}
          title={threeDSecurity}
          visible={true}
          onCancel={() => modalAction('threeDSecureModalVisible', false)}
          closeIcon={<CustomImage src={modalClose} />}
        >
          <embed src={threeDSecureContent} width="100%" height="400" />
        </CustomModal>
      )}

      {modals.payWithNewCard && (
        <PayWithNewCard
          setModalVisible={(value) => modalAction('payWithNewCard', value)}
          saveAction={saveNewCardPayLater}
          paymentLater={paymentLater}
          orderDate={currentCardOrder?.cardActivationDate}
          setPaymentOrderDueDate={setPaymentOrderDueDate}
          formVisible={formVisible}
          form={form}
        />
      )}
      {modals.payWithEftHavale && (
        <PayWithEFTHavale
          modalAction={(value) => modalAction('payWithEftHavale', value)}
          paymentAction={paymentLater}
          orderDate={currentCardOrder?.cardActivationDate}
        />
      )}
      {modals.payWithNewCardForCompliment && (
        <PayWithNewCardCompliments
          setModalVisible={(value, clickValue) => {
            if (!value && !isMarketVou) {
              setEnteredComplimentsModal(true);
              setEnteredComplimentsClickValue(clickValue);
            }
            modalAction('payWithNewCardForCompliment', value);
          }}
          form={form}
          clickHandler={(val) => showPaymentLaterSecondStep(val)}
          selectedIndex={selectedStoredCard}
        />
      )}
      {modals.payWithSavedCardForCompliment && (
        <PayWithSavedCardCompliments
          setModalVisible={(value) => modalAction('payWithSavedCardForCompliment', value)}
          form={form}
          clickHandler={(val) => showSavedPaymentLaterSecondStep(val)}
          selectedIndex={selectedStoredCard}
        />
      )}
    </div>
  );
};

OrderSummary.propTypes = {
  form: PropTypes.any,
  formVisible: PropTypes.any,
};
export default OrderSummary;
